(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadsloth-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activateTab = (root, button, focusButton) => {
      const buttons = Array.from(root.querySelectorAll('[data-tab-button]'));
      const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));
      const target = button.dataset.target;

      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.dataset.panel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (focusButton) button.focus();
    };

    const bindSection = (root) => {
      if (root.dataset.tabsReady === 'true') return;
      root.dataset.tabsReady = 'true';

      const tablist = root.querySelector('[role="tablist"]');
      if (!tablist) return;

      tablist.addEventListener('click', (event) => {
        const button = event.target.closest('[data-tab-button]');
        if (button) activateTab(root, button, false);
      });

      tablist.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const buttons = Array.from(tablist.querySelectorAll('[data-tab-button]'));
        const currentIndex = buttons.indexOf(document.activeElement);
        if (currentIndex < 0) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
        activateTab(root, buttons[nextIndex], true);
      });
    };

    const bindAll = (scope = document) => {
      scope.querySelectorAll('[data-collection-tabs]').forEach(bindSection);
    };

    bindAll();

    document.addEventListener('shopify:section:load', (event) => {
      bindAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-collection-tabs]');
      const button = event.target.matches('[data-tab-button]')
        ? event.target
        : event.target.querySelector('[data-tab-button]');
      if (root && button) activateTab(root, button, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadsloth-header-alternative"] && !Shopify.designMode) return;
  try {
    
  const bindSadslothAlternativeHeader = (header) => {
    if (header.dataset.headerAlternativeBound === 'true') return;
    const drawer = header.querySelector('.sadsloth-header-alt__drawer');
    if (!drawer) return;

    drawer.querySelector('[data-header-drawer-close]')?.addEventListener('click', () => {
      drawer.removeAttribute('open');
    });

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => drawer.removeAttribute('open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') drawer.removeAttribute('open');
    });

    header.dataset.headerAlternativeBound = 'true';
  };

  document.querySelectorAll('.sadsloth-header-alt').forEach(bindSadslothAlternativeHeader);
  document.addEventListener('shopify:section:load', (event) => {
    const header = event.target.querySelector('.sadsloth-header-alt');
    if (header) bindSadslothAlternativeHeader(header);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadsloth-reviews-alternative"] && !Shopify.designMode) return;
  try {
    
  const bindSadslothAlternativeReviews = (section) => {
    if (section.dataset.altReviewsBound === 'true') return;

    const track = section.querySelector('[data-alt-review-track]');
    const arrows = section.querySelectorAll('[data-alt-review-direction]');
    const dialog = section.querySelector('[data-alt-review-dialog]');
    const dialogImage = dialog?.querySelector('img');

    if (track && arrows.length > 0) {
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        arrows[0].disabled = track.scrollLeft <= 2;
        arrows[1].disabled = track.scrollLeft >= maximum - 2;
      };

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const card = track.querySelector('.ss-review-alt__card');
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          track.scrollBy({ left: distance * Number(arrow.dataset.altReviewDirection), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    if (dialog && dialogImage && typeof dialog.showModal === 'function') {
      section.querySelectorAll('[data-alt-review-image]').forEach((button) => {
        button.addEventListener('click', () => {
          const image = button.querySelector('img');
          if (!image) return;
          dialogImage.src = image.currentSrc || image.src;
          dialogImage.alt = image.alt;
          dialog.showModal();
        });
      });

      dialog.querySelector('[data-alt-review-dialog-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    section.dataset.altReviewsBound = 'true';
  };

  document.querySelectorAll('.ss-review-alt').forEach(bindSadslothAlternativeReviews);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.ss-review-alt');
    if (section) bindSadslothAlternativeReviews(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadsloth-reviews"] && !Shopify.designMode) return;
  try {
    
  (()=>{const bind=section=>{if(!section||section.dataset.reviewGalleryBound==='true')return;section.dataset.reviewGalleryBound='true';const dialog=section.querySelector('[data-review-gallery]'),open=section.querySelector('[data-review-gallery-open]'),close=section.querySelector('[data-review-gallery-close]'),list=section.querySelector('[data-review-gallery-list]'),load=section.querySelector('[data-review-gallery-load]'),source=section.querySelector('[data-review-gallery-templates]');if(!dialog||!open||!list||!source)return;const batch=Number(source.dataset.batchSize||8),templates=[...source.querySelectorAll('[data-review-template]')];let shown=0;const render=(reset=false)=>{if(reset){list.replaceChildren();shown=0}templates.slice(shown,shown+batch).forEach(template=>list.append(template.content.cloneNode(true)));shown=Math.min(shown+batch,templates.length);load.hidden=shown>=templates.length};open.addEventListener('click',()=>{render(true);dialog.showModal();document.documentElement.style.overflow='hidden'});close?.addEventListener('click',()=>dialog.close());load?.addEventListener('click',()=>render());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});dialog.addEventListener('close',()=>{document.documentElement.style.overflow=''})};document.querySelectorAll('.ss-reviews').forEach(bind);document.addEventListener('shopify:section:load',event=>bind(event.target.querySelector('.ss-reviews')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadsloth-ugc"] && !Shopify.designMode) return;
  try {
    
  (()=>{const bind=section=>{if(!section||section.dataset.ugcGalleryBound==='true')return;section.dataset.ugcGalleryBound='true';const gallery=section.querySelector('[data-ugc-gallery]'),galleryOpen=section.querySelector('[data-ugc-gallery-open]'),galleryClose=section.querySelector('[data-ugc-gallery-close]'),list=section.querySelector('[data-ugc-gallery-list]'),load=section.querySelector('[data-ugc-gallery-load]'),source=section.querySelector('[data-ugc-gallery-templates]'),viewer=section.querySelector('[data-ugc-viewer]'),viewerClose=section.querySelector('[data-ugc-viewer-close]'),viewerContent=section.querySelector('[data-ugc-viewer-content]');if(!source||!viewer||!viewerContent)return;const cardTemplates=[...source.querySelectorAll('[data-ugc-card-template]')],viewerTemplates=[...source.querySelectorAll('[data-ugc-viewer-template]')],batch=Number(source.dataset.batchSize||8);let shown=0;const render=(reset=false)=>{if(reset){list.replaceChildren();shown=0}cardTemplates.slice(shown,shown+batch).forEach(template=>list.append(template.content.cloneNode(true)));shown=Math.min(shown+batch,cardTemplates.length);load.hidden=shown>=cardTemplates.length};const openViewer=index=>{const template=viewerTemplates.find(item=>Number(item.dataset.index)===Number(index));if(!template)return;viewerContent.replaceChildren(template.content.cloneNode(true));viewer.showModal();document.documentElement.style.overflow='hidden'};galleryOpen?.addEventListener('click',()=>{render(true);gallery.showModal();document.documentElement.style.overflow='hidden'});galleryClose?.addEventListener('click',()=>gallery.close());load?.addEventListener('click',()=>render());section.addEventListener('click',event=>{const initial=event.target.closest('[data-ugc-preview]'),modal=event.target.closest('[data-ugc-modal-item]');if(initial)openViewer(initial.dataset.ugcPreview);if(modal)openViewer(modal.dataset.ugcModalItem)});viewerClose?.addEventListener('click',()=>viewer.close());gallery?.addEventListener('click',event=>{if(event.target===gallery)gallery.close()});viewer.addEventListener('click',event=>{if(event.target===viewer)viewer.close()});gallery?.addEventListener('close',()=>{if(!viewer.open)document.documentElement.style.overflow=''});viewer.addEventListener('close',()=>{viewerContent.replaceChildren();if(!gallery?.open)document.documentElement.style.overflow=''})};document.querySelectorAll('.ss-ugc').forEach(bind);document.addEventListener('shopify:section:load',event=>bind(event.target.querySelector('.ss-ugc')))})();

  } catch(e) { console.error(e); }
})();
})();
